/**
 * Map slice async fields (`loading`, `error`, `data`) to simple UI flags.
 * Keep pages consistent: loader while fetching, error only when `!loading`.
 *
 * **Loaders:** wrap filters + table + pagination with `ContentLoader` from `Utility/Loader` so the
 * sidebar stays visible and the spinner centers in the main column; use `Loader` (default
 * `fullScreen`) for full-viewport blocking loads.
 *
 * @param {boolean} loading — from `selectXxxLoading`
 * @param {string | null | undefined} error — from `selectXxxError`
 * @param {unknown} [data] — from `selectXxxData` (optional; for `hasData`)
 */
export function useAsyncResource(loading, error, data) {
  return {
    showLoader: Boolean(loading),
    showError: Boolean(error) && !loading,
    errorMessage: error ?? null,
    hasData: data != null,
  };
}
